<template>
  <div class="modal-overlay">
    <div class="modal">
      <div class="modal-header">
        <h2 class="modal-title">{{ $t('alternativePayModal.current_bill') }}</h2>
        <button class="close-btn" @click="closeModal">✕</button>
      </div>

      <div class="modal-content">
        <div class="modal-description__wrapper">
          <p class="modal-description">
            {{ $t('alternativePayModal.description') }}
          </p>

          <div class="currency-options">
            <div
              class="currency-option"
              :class="{ active: selectedCurrency === alternativeCurrency }"
              @click="selectCurrency(alternativeCurrency)"
            >
              <div class="currency-code">{{ alternativeCurrency }}</div>
              <div class="currency-amount">{{ alternativeAmount }}</div>
            </div>
            <div
              class="currency-option"
              :class="{ active: selectedCurrency === currentCurrency }"
              @click="selectCurrency(currentCurrency)"
            >
              <div class="currency-code">{{ currentCurrency }}</div>
              <div class="currency-amount">{{ currentAmount }}</div>
            </div>
          </div>
        </div>

        <div class="service-fee">
          <QrCheckbox :checked="isAgree" @change="changeAgree" />
          <span class="fee-text">{{ $t('alternativePayModal.fee_text', {percent: selectedFee}) }}</span>
        </div>

        <p class="payment-note">
          {{ $t('alternativePayModal.payment_note', {currency: selectedCurrency}) }}
        </p>
        <div class="qr-order__actions-buttons">
          <div role="button" :class="['qr-order__action', !isAgree && 'qr-order__action--disabled']" @click="pay()">
            {{ $t('qrOrder.toPay') }}
          </div>
          <div role="button" class="qr-order__action" @click="closeModal">
            {{ $t('qrOrder.toCancel') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrCheckbox from './QrCheckbox'

export default {
  name: 'OrderScreen',
  components: {
    QrCheckbox,
  },
  props: {
    alternativePayInfo: {
      type: Object,
      default: () => ({})
    },
    currentFee: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      selectedCurrency: this.alternativePayInfo.currency,
      isAgree: true,
    }
  },
  computed: {
    currentCurrency() {
      return this.alternativePayInfo.currency
    },
    alternativeCurrency() {
      return this.alternativePayInfo.alternative_currency
    },
    currentAmount() {
      return this.alternativePayInfo.total
    },
    alternativeAmount() {
      return this.alternativePayInfo.alternative_bank_total
    },
    alternativeFee() {
      return this.alternativePayInfo.alternative_bank_percent
    },
    selectedFee() {
      return this.selectedCurrency === this.currentCurrency ? this.currentFee : this.alternativeFee
    }
  },
  methods: {
    closeModal() {
      this.$emit('cancelPay')
    },
    selectCurrency(currency) {
      this.selectedCurrency = currency
    },
    pay() {
      this.$emit('pay', this.selectedCurrency === this.alternativeCurrency)
    },
    changeAgree(value) {
      this.isAgree = value
    },
  },
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.alternative-pay {
  background-color: rgba(51, 51, 51, 1);
  min-height: 400px;
  width: 100%;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: flex-end;
  z-index: 10;
}

.modal {
  background: #2a2a2a;
  border-radius: 20px 20px 0 0;
  width: 100%;
  max-height: 70%;
  padding-bottom: 18px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  height: 72px;
}

.modal-title {
  @include font(20, 24, 600);
  color: $white;
}

.close-btn {
  background: #444;
  border: none;
  color: $white;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  cursor: pointer;
  font-size: 16px;
}

.modal-description__wrapper {
  background-color: rgba(0, 0, 0, 0.2);
  padding: 30px 16px;
}

.modal-description {
  color: rgba(184, 161, 94, 1);

  @include font(15, 16, 400);
  text-align: left;
  margin-bottom: 20px;
  margin-top: 0;
}

.currency-options {
  display: flex;
  gap: 12px;
}

.currency-option {
  flex: 1;
  background: #444;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 64px;
  @include flex(column, center, center);
  color: rgba(171, 171, 171, 1);
}

.currency-option.active {
  background: transparent;
  border: 2px solid rgba(184, 161, 94, 1);
  color: $white;

  .currency-code {
    @include font(24, 28, 600);
  }
}

.currency-code {
  @include font(24, 21, 600);
}

.currency-amount {
  @include font(20, 21, 400);
}

.service-fee {
  @include flex(row, flex-start, center);
  gap: 10px;
  padding: 20px 16px;
}

.fee-text {
  @include font(15, 12, 400);
  color: rgba(148, 148, 148, 1);
}

.payment-note {
  width: 100%;
  padding-left: 48px;
  @include font(10, 11, 400);
  color: rgba(148, 148, 148, 1);
  text-align: left;
  margin: 0 0 24px 0;
  padding-right: 16px;
}


.qr-order {
  &__actions-buttons {
    background: rgb(41, 41, 41);
    border-radius: 24px;
    margin: 0 16px;
    padding: 2px;
    background-color: rgb(51, 51, 51);
    gap: 7px;
    height: 48px;
    @include flex(row, flex-start, center);
  }

  &__action {
    width: 100%;
    border-radius: 24px;
    height: 100%;
    background: $white;
    color: $black;
    @include flex(row, center, center);
    @include font(15, 18, 600);
    text-transform: uppercase;

    &--disabled {
      opacity: 0.3;
      pointer-events: none;
    }
  }
}
</style>
